import cx from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import { Container } from 'flux/utils';
import { throttle } from 'lodash';

import ClassNavigationPromotionContainer from 'groups/containers/ClassNavigationPromotionContainer.jsx';
import AffiliationStore from 'stores/AffiliationStore';
import ClassNavigationHeader from 'groups/components/ClassNavigationHeader.jsx';
import CurrentUser from 'auth/CurrentUser';
import Divider from 'components/Divider.jsx';
import GroupsNav from 'groups/components/GroupsNav.jsx';
import GroupStore from 'groups/stores/GroupStore';
import SettingsStore from 'stores/SettingsStore';
import { getOrderedSectionInfo } from 'groups/lib/groupNavigation';

import styles from './styles/ClassNavigation.css';

class ClassNavigation extends React.Component {
  static getStores() {
    return [
      CurrentUser,
      GroupStore,
      SettingsStore,
      AffiliationStore,
    ];
  }

  static calculateState() {
    const user = CurrentUser.getUser();
    const settings = SettingsStore.getSettings();
    const hasAdminConsole = user.hasFeature('web_admin_console');

    const ownedGroups = GroupStore.getOwnedGroups();
    const subscribedGroups = GroupStore.getSubscribedGroups();
    const districtGroups = GroupStore.getDistrictGroups();
    const schoolGroups = GroupStore.getSchoolGroups();
    const organizations = AffiliationStore.getAffiliatedOrganizations();
    const userCanOwnGroups = user.canOwnGroups();
    const maxGroups = settings.groups && settings.groups.limit || Number.POSITIVE_INFINITY;
    const canAddGroup = user.canCreateGroups() && (GroupStore.getOwnedGroups().length < maxGroups);
    const isMuted = user.isMuted();
    const mutedUntil = user.getMutedUntil();

    const sections = getOrderedSectionInfo({
      organizations,
      districtGroups,
      schoolGroups,
      ownedGroups,
      subscribedGroups,
      userCanOwnGroups,
      options: {
        ignoreDistrictSection: !hasAdminConsole,
        ignoreDistrictOrganizationSection: hasAdminConsole,
      },
    });

    return {
      sections,
      canAddGroup,
      isMuted,
      mutedUntil,
    };
  }

  componentDidMount() {
    this.handleScroll = throttle(this.handleScroll, 100);
  }

  handleScroll = () => {
    const scrollTop = ReactDOM.findDOMNode(this.refs.nav).scrollTop;
    if (this.state.showDivider && scrollTop === 0) {
      this.setState({ showDivider: false });
    } else if (!this.state.showDivider && scrollTop > 0) {
      this.setState({ showDivider: true });
    }
  }

  render() {
    return (
      <div className={cx(styles.this, this.props.className)}>
        <ClassNavigationHeader ref="header" />
        <ClassNavigationPromotionContainer />
        {this.state.showDivider && <Divider className={styles.divider} size="small" />}
        <GroupsNav
          ref="nav"
          className={styles.classList}
          onScroll={this.handleScroll}
          {...this.state}
        />
      </div>
    );
  }
}

export default Container.create(ClassNavigation);



// WEBPACK FOOTER //
// ./src/groups/components/ClassNavigation.jsx